import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  viewOrder,
  setCheckoutDetailConfirmed,
} from "../../redux/actionCreators/orderAndPayments"
import "./CheckoutPage.scss"
import _ from "../../utils/lodashUtils"
import BlockingModal from "../../components/BlockingModal/BlockingModal"
import {
  FirebaseService,
  FIREBASE_STATE_KEYS,
  FirebaseContext,
} from "../../firebase"
import { emptyDeliveryDotComCart } from "../../redux/actionCreators/planDinnner"
import { Row } from "antd"
import { ArrowLeftOutlined } from "@ant-design/icons"
import {
  GO_BACK_FROM_CHECKOUT_WAITING,
  PARTNER_GO_BACK_FROM_CHECKOUT_WAITING,
  WAITING_TO_CONFIRM_ORDER,
  WAITING_FOR_PARTNER_TO_PAY,
  WAITING_FOR_PAYMENT_PAGE,
  YOU_PAY_SELF,
  YOU_PAY_BOTH,
  BACK_FROM_CHECKOUT_WAITING,
  GO_BACK_CONTENT,
  PARTNER_PAY_BOTH,
} from "../../constants/messages"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import CheckoutPartnerAway from "./CheckoutPartnerAway"
import { PageHeader } from "../../molecules/PageHeader"
import {
  getPartnerNameorNickName,
  getGenderSpecificMessage,
  checkCheckoutPartnerAway,
} from "../../utils/helpers"
import WaitingCat from "../../assets/images/loading-cat.gif"
import { emitter } from "../../utils/emitter"
import { CUSTOM_EVENTS } from "../../constants/commons"
import { goBackToPlanADate } from "./CheckoutUtils"

const CheckoutWaitingPage = props => {
  const { viewOrder, user, isLoading, setCheckoutDetailConfirmed } = props

  const [
    partnerCheckedOutModalVisibility,
    setpartnerCheckedOutModalVisibility,
  ] = useState(false)

  const [
    userCancellingModalVisibility,
    setuserCancellingModalVisibility,
  ] = useState(false)

  const { userState, dateState, partnerState } = React.useContext(
    FirebaseContext
  )
  const userUUID = _.get(userState, "userDetails.uuid")
  const partnerUUID = _.get(partnerState, "userDetails.uuid")
  const showPartnerAway = checkCheckoutPartnerAway(partnerState, dateState)

  const userActiveRoute = _.get(userState, FIREBASE_STATE_KEYS.ACTIVE_ROUTE)

  useEffect(() => {
    if (userActiveRoute !== "/checkout/wait")
      props.history.push(userActiveRoute)
  }, [userActiveRoute])

  useEffect(() => {
    viewOrder(false, acceptedRestaurantId)
  }, [])

  const toggleUserCancelingModal = value => () => {
    setuserCancellingModalVisibility(value)
  }

  useEffect(() => {
    const showUserCancelingModalListner = emitter.addListener(
      CUSTOM_EVENTS.SHOW_USER_CANCELLING_CHECKOUT_MODAL,
      toggleUserCancelingModal(true)
    )
    const hideUserCancelingModalListner = emitter.addListener(
      CUSTOM_EVENTS.HIDE_USER_CANCELLING_CHECKOUT_MODAL,
      toggleUserCancelingModal(false)
    )

    return () => {
      showUserCancelingModalListner.remove()
      hideUserCancelingModalListner.remove()
    }
  }, [])

  // Check and redirect user to order success page if the order is complete
  const userOrderId = _.get(userState, FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID)
  const firebasePayStatus = _.get(dateState, "payStatus", {})

  useEffect(() => {
    if (userOrderId !== undefined) {
      async function _goBackToPlanADate() {
        await goBackToPlanADate(
          props,
          dateState,
          userState,
          partnerState,
          isOrderCombined
        )
      }
      _goBackToPlanADate()
    }
  }, [userOrderId])

  const isOrderCombined = _.get(
    dateState,
    FIREBASE_STATE_KEYS.IS_ORDER_COMBINED
  )

  const partnerOrderId = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID
  )
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const partnerName = getPartnerNameorNickName(partnerState)
  const partnerGender = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender")
  )
  const partnerGenderPosessive = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender"),
    "POSSESSIVE"
  )
  const partnerWant = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender"),
    "WANT"
  )
  const displayName = _.get(userState, "userDetails.display_name")
  const userGender = getGenderSpecificMessage(
    _.get(userState, "userDetails.gender"),
    "POSSESSIVE"
  )
  const acceptedRestaurantId =
    acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]

  // Check if there is any update in partner screen
  // and update the screen based on the input
  useEffect(() => {
    if (partnerOrderId && isOrderCombined) {
      async function _goBackToPlanADate() {
        await goBackToPlanADate(
          props,
          dateState,
          userState,
          partnerState,
          isOrderCombined
        )
      }
      _goBackToPlanADate()
    }
  }, [partnerOrderId])

  useEffect(() => {
    if (firebasePayStatus) {
      const payStatus = firebasePayStatus
      const partnerPage = _.get(
        firebasePayStatus,
        `${partnerUUID}.state`,
        "CHECKOUT"
      )
      if (payStatus.userPickedTab === user.uuid && partnerPage === "WAITING") {
        FirebaseService.write(
          "PAYMENT",
          `${FirebaseService.getDefaultPath()}${[
            FIREBASE_STATE_KEYS.PAY_STATUS,
          ]}/${[userUUID]}/state/`
        )
        FirebaseService.setActiveRoute("/checkout/payment")
        props.history.push("/checkout/payment")
      }
      if (payStatus.status === "CANCELLED" && !userCancellingModalVisibility) {
        setpartnerCheckedOutModalVisibility(true)
      }
    }
  }, [props.date, partnerOrderId])

  const navigateToCheckoutDetailPage = () => {
    emitter.fire(CUSTOM_EVENTS.SHOW_USER_CANCELLING_CHECKOUT_MODAL, [])
  }

  const getMessage = () => {
    let msg = ""
    if (firebasePayStatus.userPickedTab === user.uuid) {
      msg = WAITING_TO_CONFIRM_ORDER(partnerName, userGender)
    } else if (firebasePayStatus) {
      msg = WAITING_FOR_PARTNER_TO_PAY(partnerName)
    } else {
      msg = WAITING_FOR_PAYMENT_PAGE
    }
    return msg
  }

  const headerText = isOrderCombined
    ? PARTNER_PAY_BOTH(partnerName, partnerGender)
    : firebasePayStatus.status === "SELF"
    ? YOU_PAY_SELF
    : firebasePayStatus.userPickedTab === user.uuid
    ? YOU_PAY_BOTH
    : props.date
    ? PARTNER_PAY_BOTH(partnerName, partnerGender)
    : ""

  // Disable back buttons for partner in combine order and pick tab scenario
  const backButtonDisabled =
    (isOrderCombined ||
    (firebasePayStatus.status === "BOTH" &&
      firebasePayStatus.userPickedTab !== user.uuid)
      ? true
      : false) || showPartnerAway

  const getWaitingContent = () => {
    return (
      <React.Fragment>
        <CheckoutPartnerAway {...props} />
        <div className="checkout-wait-container">
          <BlockingModal
            withOptions
            title={GO_BACK_FROM_CHECKOUT_WAITING}
            content={GO_BACK_CONTENT(partnerName)}
            blockingModalVisibility={userCancellingModalVisibility}
            continueHandler={async () => {
              await FirebaseService.write(
                {
                  ...firebasePayStatus,
                  [userUUID]: { state: "CHECKOUT" },
                  status: "CANCELLED",
                },
                `${FirebaseService.getDefaultPath()}${[
                  FIREBASE_STATE_KEYS.PAY_STATUS,
                ]}`
              )
              emitter.fire(
                CUSTOM_EVENTS.HIDE_USER_CANCELLING_CHECKOUT_MODAL,
                []
              )
              setCheckoutDetailConfirmed(false)
              await FirebaseService.setActiveRoute("/checkout")
              props.history.push("/checkout")
            }}
            cancelHandler={() =>
              emitter.fire(
                CUSTOM_EVENTS.HIDE_USER_CANCELLING_CHECKOUT_MODAL,
                []
              )
            }
          />
          <BlockingModal
            title={PARTNER_GO_BACK_FROM_CHECKOUT_WAITING(
              partnerName,
              partnerGenderPosessive,
              partnerWant
            )}
            blockingModalVisibility={partnerCheckedOutModalVisibility}
            continueHandler={async () => {
              await FirebaseService.write(
                {
                  ...firebasePayStatus,
                  [userUUID]: { state: "CHECKOUT" },
                  status: "CANCELLED",
                },
                `${FirebaseService.getDefaultPath()}${[
                  FIREBASE_STATE_KEYS.PAY_STATUS,
                ]}`
              )
              await FirebaseService.setActiveRoute("/checkout")
              props.history.push("/checkout")
            }}
          />
          <div className="order-receipt">
            <Row id="KitchenText">
              <PageHeader
                btnText={BACK_FROM_CHECKOUT_WAITING}
                icon={<ArrowLeftOutlined />}
                headerText={headerText}
                disabled={backButtonDisabled}
                onClick={navigateToCheckoutDetailPage}
                windowState={false}
              />
            </Row>
            <div className="checkout-waiting">
              <div>{getMessage()}</div>
              <img
                className="cat-waiting-img"
                src={WaitingCat}
                alt="waiting cat"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  return <div id="CheckoutPage">{isLoading ? null : getWaitingContent()}</div>
}

const mapStateToProps = state => {
  const {
    orderAndPayments: {
      cartDetailsPartner1,
      cartDetailsPartner2,
      isLoading,
      payStatus,
      partnerConfirmedCheckoutDetails,
      checkoutHeaderMessage,
      confirmedCheckoutDetail,
      paymentStatus,
    },
    planDinner: { restaurantSuggested },
    invitePeople: { partnerDetails },
    auth: {
      user,
      partner: { display_name },
    },
  } = state
  return {
    cartDetailsPartner1,
    cartDetailsPartner2,
    restaurantSuggested,
    partnerDetails,
    user,
    isLoading,
    payStatus,
    partnerConfirmedCheckoutDetails,
    checkoutHeaderMessage,
    confirmedCheckoutDetail,
    paymentStatus,
    display_name,
  }
}
export default connect(mapStateToProps, {
  viewOrder,
  invitePartnerToChat,
  emptyDeliveryDotComCart,
  setCheckoutDetailConfirmed,
})(CheckoutWaitingPage)
